import { defineMessages } from 'react-intl';

export default defineMessages({
    verbalAuthorization: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.Verbal Authorization',
        defaultMessage: 'Verbal Authorization'
    },
    formsEligible: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.formsEligible',
        defaultMessage: 'The following forms are eligible for verbal authorization.'
    },
    agentScript: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.Agent Script',
        defaultMessage: 'Agent Script'
    },
    verballyAuthorized: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.Verbally authorized',
        defaultMessage: 'Verbally authorized'
    },
    et: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.ET',
        defaultMessage: 'ET'
    },
    iAccept: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.I accept',
        defaultMessage: 'I accept'
    },
    ut: {
        id: 'ml.gateway.quoteandbind.common.verbalAuthorization.UT',
        defaultMessage: 'UT'
    },
})